"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const moment_1 = __importDefault(require("moment"));
const get_1 = __importDefault(require("lodash/get"));
const orderBy_1 = __importDefault(require("lodash/orderBy"));
const groupBy_1 = __importDefault(require("lodash/groupBy"));
const core_1 = require("@material-ui/core");
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const ExpandMore_1 = __importDefault(require("@material-ui/icons/ExpandMore"));
const logInfo_1 = __importDefault(require("../modals/logInfo"));
const expertsSlice_1 = require("../../../../redux/slices/expertsSlice");
const modalsSlice_1 = require("../../../../redux/slices/modalsSlice");
const tableHead = [
    {
        key: "Requester",
        value: "data.requester.name"
    }, {
        key: "Directory type",
        value: "data.type"
    }, {
        key: "Response count",
        value: "data.responseCount"
    }, {
        key: "Request Time",
        value: "ingestionTime"
    }
];
const getTableCell = (row, val, key) => {
    let cell = (react_1.default.createElement("span", null, get_1.default(row, val.value) || 'N/A'));
    const data = get_1.default(row, val.value);
    if (val.value === 'ingestionTime') {
        cell = (react_1.default.createElement("span", null, data ? moment_1.default(data).format('YYYY-MM-DD HH:mm') : 'N/A'));
    }
    else if (val.value == 'data.type') {
        cell = (react_1.default.createElement("span", null, data === 0 ? 'Expert' : data === 1 ? 'Service' : 'N/A'));
    }
    return (react_1.default.createElement(core_1.TableCell, { key: key }, cell));
};
const QueryLogs = (props) => {
    const { queryLogs } = props;
    const grouped = queryLogs ? groupBy_1.default(queryLogs === null || queryLogs === void 0 ? void 0 : queryLogs.events, 'data.requester.name') : {};
    const openModal = () => props.triggerModal({ key: 'experts.queryLogs', val: true });
    const mapped = Object.keys(grouped).map((val, key) => {
        return (react_1.default.createElement(core_1.ExpansionPanel, { key: key },
            react_1.default.createElement(core_1.ExpansionPanelSummary, { expandIcon: react_1.default.createElement(ExpandMore_1.default, null), "aria-controls": "panel1a-content", id: "panel1a-header" },
                react_1.default.createElement(Typography_1.default, { className: "" }, val)),
            react_1.default.createElement(core_1.ExpansionPanelDetails, null,
                react_1.default.createElement(core_1.TableContainer, { className: "clearfix", style: { overflowX: "auto", width: "100%" } },
                    react_1.default.createElement(core_1.Table, { "aria-label": "experts table", className: "table admin-panel-table table-history admin-users-table" },
                        react_1.default.createElement(core_1.TableHead, { className: "admin-panel-table-thead" },
                            react_1.default.createElement(core_1.TableRow, null, tableHead.map((val, key) => (react_1.default.createElement(core_1.TableCell, { key: key }, val.key))))),
                        react_1.default.createElement(core_1.TableBody, null, orderBy_1.default((grouped[val] || []), ['timestamp'], ['desc']).map((row, key) => {
                            return (react_1.default.createElement(core_1.TableRow, { style: {
                                    cursor: "pointer"
                                }, onClick: () => {
                                    openModal();
                                    props.viewLog(row);
                                }, key: key }, tableHead.map((val, key) => getTableCell(row, val, key))));
                        })))))));
    });
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement("div", { className: "row", style: {
                margin: "10px 0"
            } },
            react_1.default.createElement("div", null, mapped),
            react_1.default.createElement(logInfo_1.default, null))));
};
const mapStateToProps = (state) => {
    const { experts } = state;
    return {
        queryLogs: experts.queryLogs,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getQueryLogs: (data) => dispatch(expertsSlice_1.getQueryLogs(data)),
        triggerModal: (data) => dispatch(modalsSlice_1.triggerModal(data)),
        viewLog: (data) => dispatch(expertsSlice_1.viewLog(data)),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(QueryLogs);
